import { GlButton, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__, sprintf } from '~/locale';
import { isLoggedIn } from '~/lib/utils/common_utils';
import ForksButton from '/builds/gitlab/gitlab-ee/app/assets/javascripts/forks/components/forks_button.vue?vue3';
import NotificationsDropdown from '/builds/gitlab/gitlab-ee/app/assets/javascripts/notifications/components/notifications_dropdown.vue?vue3';
import StarCount from '/builds/gitlab/gitlab-ee/app/assets/javascripts/stars/components/star_count.vue?vue3';
import getProjectByPath from '~/graphql_shared/queries/get_project_by_path.graphql';
import { ACTION_COPY_ID } from '~/vue_shared/components/list_actions/constants';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { formatProject } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/projects/home_panel/formatter.js?vue3';
import ProjectHeaderActions from '/builds/gitlab/gitlab-ee/app/assets/javascripts/projects/home_panel/components/header_actions.vue?vue3';
export default {
    name: 'HomePanelApp',
    components: {
        ForksButton,
        GlButton,
        ProjectHeaderActions,
        NotificationsDropdown,
        StarCount
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: {
        adminPath: {
            default: ''
        },
        canReadProject: {
            default: false
        },
        isProjectEmpty: {
            default: false
        },
        projectId: {
            default: ''
        },
        projectFullPath: {
            default: ''
        }
    },
    props: {
        canRequestAccess: {
            type: Boolean,
            required: true
        },
        canWithdrawAccessRequest: {
            type: Boolean,
            required: true
        },
        requestAccessPath: {
            type: String,
            required: true
        },
        withdrawAccessRequestPath: {
            type: String,
            required: true
        },
        dashboardPath: {
            type: String,
            required: true
        }
    },
    apollo: {
        project: {
            query: getProjectByPath,
            update (data) {
                return formatProject(data.project, {
                    canWithdrawAccessRequest: this.canWithdrawAccessRequest,
                    canRequestAccess: this.canRequestAccess,
                    requestAccessPath: this.requestAccessPath,
                    withdrawAccessRequestPath: this.withdrawAccessRequestPath
                });
            },
            variables () {
                return {
                    fullPath: this.projectFullPath
                };
            },
            error () {
                createAlert({
                    message: s__('GroupProjectActions|Something went wrong while loading the actions dropdown list. Please refresh the page and try again.')
                });
            },
            skip () {
                return !isLoggedIn();
            }
        }
    },
    data () {
        return {
            isLoggedIn: isLoggedIn(),
            project: {
                id: this.projectId,
                availableActions: [
                    ACTION_COPY_ID
                ]
            }
        };
    },
    computed: {
        canForkProject () {
            return !this.isProjectEmpty && isLoggedIn() && this.canReadProject;
        },
        copyProjectId () {
            return sprintf(s__('ProjectPage|Project ID: %{id}'), {
                id: this.projectId
            });
        },
        showActions () {
            return this.project && !this.$apollo.queries.project.loading;
        }
    },
    i18n: {
        adminButtonTooltip: __('View project in admin area')
    }
};
